import { render } from "./HomeLanding.vue?vue&type=template&id=36f4200d"
import script from "./HomeLanding.vue?vue&type=script&lang=js"
export * from "./HomeLanding.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__